import { Notification, NotificationType } from "@scrile/api-provider/dist/api/NotificationsProvider";
import { $t } from "@/lib/i18nHelpers";
import { getProfileUrl } from "@/lib/urlHelpers";
import router from "@/router";
import { NotificationData } from "@/types";

export default function(notification: Notification): NotificationData | false {
  const user = notification.user;
  if (!user) return false;
  if ([NotificationType.MEMBER_APPROVED, NotificationType.CREATOR_APPROVED].includes(notification.type)) {
    return {
      text: $t("{screenName} is new on Ciaofan - go follow them!", { screenName: user.screenName }),
      position: "top",
      timeout: 7000,
      image: {
        user: user,
      },
      onNotificationClick: () => router.push(getProfileUrl(user)),
    };
  }

  return false;
}
